import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

export default function AdminHeader() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  /* Toggle Sidebar */

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.toggle("sidebar-open");
    } else {
      document.body.classList.toggle("sidebar-collapsed");
    }
  };

  /* Close dropdown when clicking outside */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="uh-header">
      {/* LEFT */}

      <div className="uh-left">
        <button className="uh-toggle" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </button>

        <h4 className="uh-title">Admin Dashboard</h4>
      </div>

      {/* RIGHT */}

      <div className="uh-right" ref={dropdownRef}>
        <div className="uh-user" onClick={() => setOpen(!open)}>
          <i className="bi bi-person-circle"></i>

          <span>Admin</span>

          <i className="bi bi-chevron-down"></i>
        </div>

        {/* Dropdown */}

        {open && (
          <div className="uh-dropdown">
            <Link to="/admin/profile">
              <i className="bi bi-person"></i>
              Profile
            </Link>

            <Link to="/admin/change-password">
              <i className="bi bi-lock"></i>
              Change Password
            </Link>

            <Link to="/admin/logout">
              <i className="bi bi-box-arrow-right"></i>
              Logout
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
